import {PureComponent} from 'react'
import {Link} from 'react-router-dom'

import numbr from '../../media/images/partnerships/logo-numbr.svg'
import embarq from '../../media/images/partnerships/logo-embarq.svg'

import {generate} from '../../routes.js'

export default class Partnerships extends PureComponent {
  render() {
    return <section className="container text-center py-5">
      <h2 className="mb-4">Des partenariats pour vous simplifier la vie</h2>
      <p>
        Twineeds met à votre disposition des partenaires afin de pouvoir vous lancer sereinement dans votre nouvelle
        activité, que vous décidiez de rester salarié ou de vous lancer en indépendant !
      </p>
      <div className="row justify-content-center mb-4">
        <a className="col-8 col-md-3 border-0 m-4" href="https://numbr.co/" rel="noopener noreferrer" target="_blank">
          <img className="w-100" src={numbr} alt="Numbr, libres d'entreprendre !"/>
        </a>
        <a className="col-8 col-md-3 border-0 m-4" href="https://www.embarq.fr/" rel="noopener noreferrer" target="_blank">
          <img className="w-100" src={embarq} alt="Embarq : La vie d’indépendant et le confort du salariat"/>
        </a>
      </div>
      <Link className="btn btn-primary" to={generate({name: 'partnerships'})}>En savoir plus</Link>
    </section>
  }
}